define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../shared/dataLogs", "./phoneNumbersImport", "../phoneNumbers/phoneNumberActions", "../../models/UserContext", "../../utils/kendoUtils"], function (require, exports, $, ko, log, urls_1, tools, DataLogs, PhoneNumbersImport, PhoneNumberActions, UserContext, KendoUtils) {
    "use strict";
    var PhoneNumbersAudit = /** @class */ (function () {
        function PhoneNumbersAudit() {
            this.userCanBulkEdit = ko.observable(UserContext.hasAccess("Admin,PhoneNumbers.BulkEdit"));
            this.userCanBulkDelete = ko.observable(UserContext.hasAccess("Admin,PhoneNumbers.BulkDelete"));
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,PhoneNumbers.Edit,PhoneNumbers.Delete"));
            this.phoneActions = new PhoneNumberActions();
            this.canExport = UserContext.hasAccess("Admin,PhoneNumbers.Export");
            this.importModule = new PhoneNumbersImport();
            this.filterByNumber = ko.observable("");
            this.filterByEntityName = ko.observable("");
            this.filterByProvider = ko.observable(0);
            this.filterByStatus = ko.observable(0);
            this.filterByNotAssigned = ko.observable(false);
            this.filterByCustomer = ko.observable("");
            this.filterByCustomerName = ko.observable("");
        }
        PhoneNumbersAudit.prototype.init = function () {
            var self = this;
            $("#page-title").text("Phone Numbers Audit");
            tools.ajaxGet({
                url: '/PhoneNumbersAudit/GetPhoneLookupData',
                success: function (data) {
                    if (data.Success) {
                        self.phoneLookupLists = data.Data.lookupLists;
                        self.phoneLookupLists.officeLocations = ko.observableArray(data.Data.lookupLists.OfficeLocations);
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.phoneActions.removePhoneCallback = function () {
                        self.phoneNumbersTable.refresh();
                    };
                    self.phoneActions.savePhoneCallback = function () {
                        self.phoneNumbersTable.refresh();
                    };
                    self.initKendoGrid(self.phoneLookupLists.GridStructures.PhoneNumbersStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        PhoneNumbersAudit.prototype.initTableFilter = function () {
            var self = this;
            function split(val) {
                return val.split(/,\s*/);
            }
            function extractLast(term) {
                return split(term).pop();
            }
            var selectedItems = [];
            function filterSelectedCustomers(term) {
                var filteredItems = ko.utils.arrayFilter(selectedItems, function (item) {
                    return term.indexOf(item.label) > -1;
                });
                var mappedData = ko.utils.arrayMap(filteredItems, function (item) { return item.value; });
                var customersList = ko.utils.arrayGetDistinctValues(mappedData).sort();
                log.log(customersList);
                self.filterByCustomer(customersList.join(","));
            }
            $("input[name=filterCustomer]").bind("keydown", function (event) {
                if (event.keyCode === $.ui.keyCode.TAB &&
                    $(this).autocomplete("instance").menu["active"]) {
                    event.preventDefault();
                }
            }).autocomplete({
                source: function (request, response) {
                    tools.ajaxPost({
                        url: "/Customers/findCustomerByName",
                        data: { Name: extractLast(request.term) },
                        success: function (Results) {
                            response($.map(Results.Data, function (item) { return ({
                                label: item.Name,
                                value: item.Id,
                                OfficeLocations: item.OfficeLocations
                            }); }));
                        }
                    });
                },
                select: function (event, ui) {
                    var terms = split(this.value);
                    // remove the current input
                    terms.pop();
                    // add the selected item
                    terms.push(ui.item.label);
                    selectedItems.push(ui.item);
                    // add placeholder to get the comma-and-space at the end
                    terms.push("");
                    this.value = terms.join(", ");
                    filterSelectedCustomers(this.value);
                    return false;
                },
                focus: function (event, ui) {
                    event.preventDefault();
                },
                open: function (event, ui) {
                    $(this).autocomplete("widget").css("z-index", 1060);
                    $(this).keydown(function (e) {
                        if (e.keyCode === 13) {
                            $(".ui-menu-item:first a").click();
                        }
                    });
                }
            });
            self.filterByProvider.subscribe(function () {
                self.phoneNumbersTable.refresh();
            });
            self.filterByStatus.subscribe(function () {
                self.phoneNumbersTable.refresh();
            });
            self.filterByNumber.extend({ rateLimit: 200 }).subscribe(function () {
                self.phoneNumbersTable.refresh();
            });
            self.filterByEntityName.extend({ rateLimit: 200 }).subscribe(function () {
                self.phoneNumbersTable.refresh();
            });
            self.filterByCustomer.subscribe(function () {
                self.phoneNumbersTable.refresh();
            });
            self.filterByNotAssigned.subscribe(function () {
                self.phoneNumbersTable.refresh();
            });
            self.filterByCustomerName.subscribe(function () {
                if (!self.filterByCustomerName()) {
                    self.filterByCustomer(null);
                }
            });
        };
        PhoneNumbersAudit.prototype.clearFilter = function () {
            var self = this;
            self.filterByNotAssigned(false);
            self.filterByNumber(null);
            self.filterByEntityName(null);
            self.filterByProvider(null);
            self.filterByStatus(null);
            self.filterByCustomer(null);
            self.filterByCustomerName(null);
        };
        PhoneNumbersAudit.prototype.initKendoGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "65px",
                template: function (dataItem) {
                    var html = "";
                    if (UserContext.hasAccess("Admin,PhoneNumbers.Edit,PhoneNumbers.Delete")) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if ((UserContext.hasAccess("Admin,PhoneNumbers.Delete,E911.Delete") && dataItem.CustomerId && !dataItem.HasE911 && dataItem.PhoneNumberId)
                        || (UserContext.hasAccess("Admin,E911.Delete") && dataItem.CustomerId && dataItem.HasE911)) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.phoneNumbersTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/PhoneNumbersAudit/GetPhoneNumbersAuditReport",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByNumber()) {
                                    data.number = self.filterByNumber();
                                }
                                if (self.filterByEntityName()) {
                                    data.entityName = self.filterByEntityName();
                                }
                                if (self.filterByCustomer()) {
                                    data.customerIds = self.filterByCustomer();
                                }
                                if (self.filterByProvider()) {
                                    data.providerId = self.filterByProvider();
                                }
                                if (self.filterByStatus()) {
                                    data.statusId = self.filterByStatus();
                                }
                                data.onlyNotAssigned = self.filterByNotAssigned();
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#number_toolbar-template").html()),
                    columns: columns,
                    autoBind: false,
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: false
                    },
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                enableExport: {
                    entityName: "PhoneNumbersAuditView",
                    title: "Phone Numbers Audit",
                    enablePdf: false
                },
                gridId: "tblPhoneNumberKendo",
                showPagerOnTop: false,
                controller: self
            };
            self.phoneNumbersTable.initGrid(gridOptions);
            $("#tblPhoneNumberKendo").on("reinit", function (e) {
                $("#tblPhoneNumberKendo tbody").on("click", ".btn-remove", function (event) {
                    var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(this);
                    self.phoneActions.deleteNumberConfirm(dataItem.PhoneNumberId, dataItem.HasE911, dataItem.MainNumber);
                    event.preventDefault();
                }).on("click", ".btn-edit", function (event) {
                    var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(this);
                    self.phoneActions.editPhoneNumber(dataItem.PhoneNumberId, dataItem.MainNumber, dataItem.CustomerId);
                    event.preventDefault();
                }).on("click", ".numberLogs", function (event) {
                    var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(this);
                    var dataLogs = new DataLogs("PhoneNumber", dataItem.PhoneNumberId);
                    dataLogs.open("Phone number logs: " + dataItem.MainNumber);
                    event.preventDefault();
                }).on("click", ".numberHistory", function (event) {
                    var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(this);
                    var dataLogs = new DataLogs("PhoneNumber", dataItem.PhoneNumberId);
                    dataLogs.openPhoneNumberHistory(dataItem.MainNumber, "Phone number logs: " + dataItem.MainNumber);
                    event.preventDefault();
                });
                self.initTableFilter();
            });
            $("#tblPhoneNumberKendo").trigger("reinit");
        };
        PhoneNumbersAudit.prototype.createNew = function () {
            var self = this;
            self.phoneActions.editPhoneNumber();
        };
        PhoneNumbersAudit.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.phoneNumbersTable.exportTo();
            }
        };
        PhoneNumbersAudit.prototype.importPhoneNumbers = function () {
            var _this = this;
            var self = this;
            self.importModule.openImport(function () {
                _this.phoneNumbersTable.getGridData().dataSource.read();
            });
        };
        PhoneNumbersAudit.prototype.refreshAuditReport = function () {
            var _this = this;
            var self = this;
            tools.ajaxGet({
                url: "/PhoneNumbersAudit/RefreshPhoneNumbersAuditReport"
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Report updated successfully");
                }
                else {
                    tools.error('Unable to refresh report');
                }
                _this.phoneNumbersTable.getGridData().dataSource.read();
            });
        };
        return PhoneNumbersAudit;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/PhoneNumbersAudit/Index")) {
            log.log("Initialize Phone numbers audit report");
            $(function () {
                (new PhoneNumbersAudit()).init();
            });
        }
    }, 0);
    return PhoneNumbersAudit;
});
//# sourceMappingURL=phoneNumbersAudit.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/phoneNumbersAudit/phoneNumbersAudit.js
// module id = 213
// module chunks = 2